import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 4"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2M16 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2M2 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2" }, null, -1)
  ]))]))
}
export default { render: render }